import { Box, Paper, Typography } from '@mui/material';
import type React from 'react';

import { BrandIdentity } from './ClientSettings/BrandIdentity';
import { CapabilityOutputOptions } from './ClientSettings/CapabilityOutputOptions';
import { FeatureFlags } from './ClientSettings/FeatureFlags';
import { PlatformEcosystems } from './ClientSettings/PlatformEcosystems';
import { SubcontractorMatchmaking } from './ClientSettings/SubcontractorMatchmaking';
import { useClientSettings } from './ClientSettings/useClientSettings';

const ClientSettingsPanel: React.FC = () => {
  const {
    isLegacyAdmin,
    hideBillingFromUsers,
    handleBillingVisibilityChange,
    generateCapabilityPitchDeck,
    setGenerateCapabilityPitchDeck,
    capabilityPitchTenderContextSlideLength,
    setCapabilityPitchTenderContextSlideLength,
    capabilityPitchPitchSlideLength,
    setCapabilityPitchPitchSlideLength,
    capabilityPitchOutputTypes,
    setCapabilityPitchOutputTypes,
    presentationEngine,
    setPresentationEngine,
    enableProcurementModule,
    setEnableProcurementModule,
    enableBiddingModule,
    setEnableBiddingModule,
    enablePartnerSearch,
    setEnablePartnerSearch,
    matchmakingCountryFilter,
    setMatchmakingCountryFilter,
    matchmakingRegionFilter,
    setMatchmakingRegionFilter,
    matchmakingMinScore,
    setMatchmakingMinScore,
    enablePartnerVisibility,
    setEnablePartnerVisibility,
    aiSettings,
    handleAiSettingChange,
    primaryColor,
    setPrimaryColor,
    secondaryColor,
    setSecondaryColor,
    fontFamily,
    setFontFamily,
    logoStoragePath,
    logoUrl,
    isUploadingLogo,
    handleLogoUpload,
  } = useClientSettings();

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Client Settings
      </Typography>
      <Paper sx={{ p: 3, mb: 3 }}>
        <FeatureFlags
          hideBillingFromUsers={hideBillingFromUsers}
          handleBillingVisibilityChange={handleBillingVisibilityChange}
        />

        {isLegacyAdmin && (
          <PlatformEcosystems
            enableBiddingModule={enableBiddingModule}
            setEnableBiddingModule={setEnableBiddingModule}
            enableProcurementModule={enableProcurementModule}
            setEnableProcurementModule={setEnableProcurementModule}
          />
        )}

        <BrandIdentity
          primaryColor={primaryColor}
          setPrimaryColor={setPrimaryColor}
          secondaryColor={secondaryColor}
          setSecondaryColor={setSecondaryColor}
          fontFamily={fontFamily}
          setFontFamily={setFontFamily}
          logoStoragePath={logoStoragePath}
          logoUrl={logoUrl}
          isUploadingLogo={isUploadingLogo}
          handleLogoUpload={handleLogoUpload}
        />

        <SubcontractorMatchmaking
          enablePartnerSearch={enablePartnerSearch}
          setEnablePartnerSearch={setEnablePartnerSearch}
          matchmakingCountryFilter={matchmakingCountryFilter}
          setMatchmakingCountryFilter={setMatchmakingCountryFilter}
          matchmakingRegionFilter={matchmakingRegionFilter}
          setMatchmakingRegionFilter={setMatchmakingRegionFilter}
          matchmakingMinScore={matchmakingMinScore}
          setMatchmakingMinScore={setMatchmakingMinScore}
          enablePartnerVisibility={enablePartnerVisibility}
          setEnablePartnerVisibility={setEnablePartnerVisibility}
        />

        <CapabilityOutputOptions
          aiSettings={aiSettings}
          handleAiSettingChange={handleAiSettingChange}
          generateCapabilityPitchDeck={generateCapabilityPitchDeck}
          setGenerateCapabilityPitchDeck={setGenerateCapabilityPitchDeck}
          capabilityPitchTenderContextSlideLength={capabilityPitchTenderContextSlideLength}
          setCapabilityPitchTenderContextSlideLength={setCapabilityPitchTenderContextSlideLength}
          capabilityPitchPitchSlideLength={capabilityPitchPitchSlideLength}
          setCapabilityPitchPitchSlideLength={setCapabilityPitchPitchSlideLength}
          capabilityPitchOutputTypes={capabilityPitchOutputTypes}
          setCapabilityPitchOutputTypes={setCapabilityPitchOutputTypes}
          presentationEngine={presentationEngine}
          setPresentationEngine={setPresentationEngine}
        />
      </Paper>
    </Box>
  );
};

export default ClientSettingsPanel;
